import { ServiceFetch } from '../service-fetch'

export default class ReceiptRequestCancelListModel extends ServiceFetch {
    getReceiptRequestCancelListBy = (data) => this.authFetch({
        url: 'receipt-request-cancel-list/getReceiptRequestCancelListBy',
        method: 'POST',
        body: JSON.stringify(data),
    })

}